import { render, staticRenderFns } from "./ProductUpsell.vue?vue&type=template&id=8e950bf4"
import script from "./ProductUpsell.vue?vue&type=script&lang=js"
export * from "./ProductUpsell.vue?vue&type=script&lang=js"
import style0 from "./scss/product-upsell.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e950bf4')) {
      api.createRecord('8e950bf4', component.options)
    } else {
      api.reload('8e950bf4', component.options)
    }
    module.hot.accept("./ProductUpsell.vue?vue&type=template&id=8e950bf4", function () {
      api.rerender('8e950bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/greenmotion-shared/Components/quotes/ProductUpsell.vue"
export default component.exports